import MessageProcessor from './MessageProcessor.js';
import {AbstractParameter} from "parameters/AbstractParameter.js";

export default class FlushMessages extends MessageProcessor {
    constructor(track) {
        super("Flush", track);

        this.flushParameter = new AbstractParameter(
            "flush",
            this,
            () => 0,
            {
                defaultValue: 4,
                min: 0,
                max: 64
            });

        this.registerParameter(this.flushParameter);
        
        this.newInlet("to flush");
        this.newInlet("control flush");

        this.newOutlet("send messages");
    }

    dispose() {
        super.dispose();

        this.disposeMessaging();
    }

    get flush() {
        return this.flushParameter.get();
    }

    processMessages() {
        let controlMessages = this.queuedMessages["control flush"];

        if (controlMessages && controlMessages.length >= this.flush) {
            // then we need to flush
            let toFlush = this.queuedMessages["to flush"];
            toFlush.forEach(
                msg => this.sendMessage('send messages', msg));
            this.clearMessages();
        }
    }
}
